import { render, staticRenderFns } from "./search-ticket.vue?vue&type=template&id=1f234a75&"
import script from "./search-ticket.vue?vue&type=script&lang=js&"
export * from "./search-ticket.vue?vue&type=script&lang=js&"
import style0 from "./search-ticket.vue?vue&type=style&index=0&id=1f234a75&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AffiliatorTicket: require('/opt/yamal.ru/src/components/affiliator/ticket.vue').default,Sulu: require('/opt/yamal.ru/node_modules/razlet-sulu-sdk/src/components/index.vue').default})
